export default __webpack_public_path__ + "static/media/shareCn2.14cc58ac.jpg";